<template>
  <canvas id="molecularCanvas"></canvas>
</template>

<script>
class MolecularNetwork {
  constructor(canvas) {
    this.canvas = canvas;
    this.ctx = this.canvas.getContext('2d');
    this.molecules = [];
    this.moleculeCount = 120;
    this.maxConnections = 5;
    this.color = { r: 0, g: 83, b: 83 };
    this.init();
  }

  init() {
    this.setCanvasSize();
    this.createMolecules();
    window.addEventListener('resize', () => this.setCanvasSize());
    this.animate();
  }

  setCanvasSize() {
    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;
  }

  createMolecules() {
    for (let i = 0; i < this.moleculeCount; i++) {
      const centerX = Math.random() * this.canvas.width;
      const centerY = Math.random() * this.canvas.height;
      const radius = Math.random() * 50 + 30 + 40;
      const speed = Math.random() * 0.002 + 0.005;
      const startAngle = Math.random() * Math.PI * 2;

      this.molecules.push({
        centerX,
        centerY,
        radius,
        speed,
        angle: startAngle,
        connections: [],
        size: Math.random() * 2 + 1,
      });
    }
  }

  drawMolecule(molecule) {
    const x = molecule.centerX + Math.cos(molecule.angle) * molecule.radius;
    const y = molecule.centerY + Math.sin(molecule.angle) * molecule.radius;

    const gradient = this.ctx.createRadialGradient(x, y, 0, x, y, molecule.size * 3);
    gradient.addColorStop(0, `rgba(${this.color.r}, ${this.color.g}, ${this.color.b}, 0.8)`);
    gradient.addColorStop(1, `rgba(${this.color.r}, ${this.color.g}, ${this.color.b}, 0)`);

    this.ctx.beginPath();
    this.ctx.arc(x, y, molecule.size * 2, 0, Math.PI * 2);
    this.ctx.fillStyle = gradient;
    this.ctx.fill();

    return { x, y };
  }

  updateConnections() {
    this.molecules.forEach(m => (m.connections = []));

    for (let i = 0; i < this.molecules.length; i++) {
      const mol1 = this.molecules[i];
      const pos1 = {
        x: mol1.centerX + Math.cos(mol1.angle) * mol1.radius,
        y: mol1.centerY + Math.sin(mol1.angle) * mol1.radius,
      };

      const connections = [];
      for (let j = 0; j < this.molecules.length; j++) {
        if (i === j) continue;

        const mol2 = this.molecules[j];
        const pos2 = {
          x: mol2.centerX + Math.cos(mol2.angle) * mol2.radius,
          y: mol2.centerY + Math.sin(mol2.angle) * mol2.radius,
        };

        const distance = Math.hypot(pos1.x - pos2.x, pos1.y - pos2.y);
        if (distance < 100) {
          connections.push({
            index: j,
            distance: distance,
          });
        }
      }

      connections.sort((a, b) => a.distance - b.distance);
      mol1.connections = connections.slice(0, this.maxConnections);
    }
  }

  drawConnections() {
    this.molecules.forEach((mol, i) => {
      const pos1 = {
        x: mol.centerX + Math.cos(mol.angle) * mol.radius,
        y: mol.centerY + Math.sin(mol.angle) * mol.radius,
      };
      if(i==0) {
        // console.log(mol.connections);
      }
      mol.connections.forEach(conn => {
        const mol2 = this.molecules[conn.index];
        const pos2 = {
          x: mol2.centerX + Math.cos(mol2.angle) * mol2.radius,
          y: mol2.centerY + Math.sin(mol2.angle) * mol2.radius,
        };

        const opacity = Math.max(0.1, 1 - conn.distance / 150);
        this.ctx.beginPath();
        this.ctx.moveTo(pos1.x, pos1.y);
        this.ctx.lineTo(pos2.x, pos2.y);
        this.ctx.strokeStyle = `rgba(${this.color.r}, ${this.color.g}, ${this.color.b}, ${opacity * 0.5})`;
        this.ctx.lineWidth = 0.3;
        this.ctx.stroke();
      });
    });
  }

  animate() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    this.molecules.forEach(molecule => {
      molecule.angle += molecule.speed;
    });

    this.updateConnections();
    this.drawConnections();

    this.molecules.forEach(molecule => this.drawMolecule(molecule));

    requestAnimationFrame(() => this.animate());
  }
}

export default {
  name: 'MolecularBackground',
  mounted() {
    new MolecularNetwork(this.$el);
  },
};
</script>

<style scoped>
canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1;
}
</style> 